<template>
  <div class="add-finance-refund">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账单主体：</span>
        </div>
        <el-select v-model="payerCode" filterable placeholder="请输入关键词查询" :loading="enterpriseLoading" size="small" style="width: 280px">
          <el-option
            v-for="item in billMainBodyList"
            :key="item._value"
            :label="item.payer"
            :value="item._value">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">关联账单：</span>
        </div>
        <el-select v-model="formData.billCode" placeholder="请选择" size="small" style="width: 280px">
          <el-option
            v-for="item in payItemDetailList"
            :key="item.billNo"
            :label="item._label"
            :value="item.billNo">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">应退金额：</span>
        </div>
        <el-input v-model="formData.refundAmount" size="small" style="width: 280px" >
          <template slot="append">元</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">实退金额：</span>
        </div>
        <el-input v-model="formData.actualRefundAmount" size="small" style="width: 280px" >
          <template slot="append">元</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">退款时间：</span>
        </div>
        <el-date-picker v-model="formData.refundTime" type="datetime" size="small" style="width: 280px" :editable=false value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择时间"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
<!--          <b class="red">*</b>-->
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>



      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {errorHandler} from '../../../utils/errorHandler'
  import {api} from '../../api/Finance'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'

  export default {
    components: {
      ButtonConfirmNext,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'deposit-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧财务',
          name: 'finance-over-view'
        }, {
          value: '退款管理'
        }],
        mainTitle: '添加退款记录',
        subheading: '',
        payChannelModifyList: [{
          key: '1',
          label: '微信'
        }, {
          key: '2',
          label: '支付宝'
        }, {
          key: '3',
          label: '银行转账'
        }, {
          key: '4',
          label: '现金'
        }, {
          key: '5',
          label: '其他'
        }],

        invoiceStatusModifyList: [{
          key: '0',
          label: '未开票'
        }, {
          key: '1',
          label: '已开票'
        }],

        enterpriseLoading: false,
        billMainBodyList: [],

        payItemDetailList: [],
        payItemDetailListChoose: [],

        payerCode: '',
        formData: {
          refundObj: '',
          enterpriseCode: '',
          personCode: '',
          billCode: '',
          billAmount: '',
          refundAmount: '',
          actualRefundAmount: '',
          refundTime: '',
          memo: '',
        }
      }
    },
    created () {
      this.currentCode = this.$route.params.id
      this.enterpriseRemoteMethod()
    },
    methods: {
      // 关键词搜索
      enterpriseRemoteMethod (query) {
        this.enterpriseLoading = true;
        this.$axios.post(api.getBillMainBodyList, {
          searchKey: query || '',
          status: '1'
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.enterpriseLoading = false;
              let data = res.data.data
              data.map(v => {
                if (v.enterpriseCode) {
                  v._value = `${v.enterpriseCode}${v.payer}`
                } else {
                  v._value = `${v.personCode}${v.payer}`
                }
              })
              this.billMainBodyList = data
            }
          })
          .catch(errorHandler('获取账单主体失败'))
      },

      toDepositManagement () {
        this.$router.push({
          name: 'finance-refund'
        })
      },

      // 获取账单列表
      getTotalBillList () {
        this.$axios.post(`${api.getTotalBillList}`, {
          personCode: this.formData.personCode,
          enterpriseCode: this.formData.enterpriseCode,
          // payer: this.formData.refundObj,
          status: '1',
        })
          .then(res => {
            let data = res.data.data
            data.map(v => {
              if (v.memo) {
                v._label = `${v.paymentItemName}/${v.money}元/${v.memo}`
              } else {
                v._label = `${v.paymentItemName}/${v.money}元`
              }
            })
            this.payItemDetailList = data
          })
          .catch(errorHandler('查询账单失败'))
      },
      confirm () {
        this.$confirm('请确认应退金额及实退金额，添加后无法修改，是否确认？', "温馨提示", {
          type: "warning"
        })
          .then(() => {
            if (!this.formData.enterpriseCode && !this.formData.personCode) {
              nError('请选择账户主体')
              return
            }
            if (!this.formData.billCode) {
              nError('请选择关联账单')
              return
            }
            if (!this.formData.refundAmount) {
              nError('请输入应退金额')
              return
            }
            if (!this.formData.actualRefundAmount) {
              nError('请输入实退金额')
              return
            }
            if (!this.formData.refundTime) {
              nError('请选择退款时间')
              return
            }
            this.$axios.post(api.addRefund, this.formData)
              .then(res => {
                if (res.data.retCode === 1) {
                  nSuccess('添加成功')
                  this.toDepositManagement()
                }
              })
              .catch(errorHandler('添加失败'))
          })
          .catch(() => {});
      },
      cancel () {
        this.toDepositManagement()
      }
    },
    watch: {
      payerCode (val) {
        this.billMainBodyList.map(v => {
          if (v._value === val) {
            this.formData.enterpriseCode = v.enterpriseCode || ''
            this.formData.personCode = v.personCode || ''
            this.formData.payer = v.payer
          }
        })
        this.formData.billCode = []
        this.formData.billAmount = ''
        this.getTotalBillList()
      },
      'formData.billCode': {
        handler(newName, oldName) {
          this.payItemDetailList.map(payItem => {
            if (payItem.billNo === this.formData.billCode) {
              this.formData.billAmount = payItem.money
            }
          })
        },
        deep: true
      },
      payItemDetailListChoose (v) {
        let bills = []
        this.payItemDetailListChoose.map(v => {

        })
        this.formData.bills = bills
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 180px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin: 40px 0;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
.add-finance-refund {
  .el-input--mini .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .el-tag.el-tag--info {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .el-select__tags-text {
      width: 100%;
      flex: 1;
      white-space: initial;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Finance/FinanceRefund/addFinanceRefund.vue